import React from 'react';
import { Card, Image, Stack, CardBody, Heading, Text, CardFooter } from '@chakra-ui/react'; // Import relevant components
import { Link } from 'react-router-dom'; // For routing
import PropTypes from 'prop-types';

const CardVertical = ({cardData}) => {
  
  CardVertical.propTypes = {
    cardData: PropTypes.shape({
      id: PropTypes.number,
      subtitle: PropTypes.string,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      linkLabel: PropTypes.string
    }),
  };
  
  return (
      <Card maxW="sm" className='column-span-3'  style={{ border: '0', boxShadow: 'none' }}>
        <CardBody p="0px">
          <Image
            src={cardData.image}
            alt="image"
            width="100%"
          />
          <Stack mt="6" spacing="3">
            <Heading size="md" className='header-main-card-vertical'>{cardData.title}</Heading>
            <Text size="md" className='header-card-vertical'>{cardData.subTitle}</Text>
            <Text>
              {cardData.description}
            </Text>
          </Stack>
        </CardBody>
        <CardFooter>
          <Link to={`seemore/${cardData.id}`}>{cardData.linkLabel}</Link>
        </CardFooter>
      </Card>
  );
};

export default CardVertical;